import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData, resetDevice } from '../../RestUtil.js';
import { TileLayer, Marker, Popup, MapContainer } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;
export default function MyMaps() {

  const [profileData, setProfileData] = useState(null);    
  const [deviceSerial, setDeviceSerial] = useState("");
  const [showMap, setShowMap] = useState(false); 
  const [position, setPosition] = useState([]);
  const [dashData1, setDashData1] = useState(null);    
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  // 17.387140,78.491684
  const zoom = 13;

  useEffect(() => {
    var pd = getLastUser();
    console.log("BE Data from MyMaps", pd);
    console.log("BE Data from MyMaps Lat", pd.lastKnownLat);
    console.log("BE Data from MyMaps Lang", pd.lastKnownLang);
    let newArr = [];
    newArr[0] = parseFloat(pd.lastKnownLat);
    newArr[1] = parseFloat(pd.lastKnownLang);
    setPosition(newArr);
    setProfileData( profileData );
    setDeviceSerial(pd.deviceSerial);
    var dashData2 = getDashboardInfo();
    console.log("BE Data from myMaps", dashData2);
    setDashData1( dashData2 );
  }, []);

  useEffect(() => {
    if (!position) return;
    if (position.length < 2) return;
    console.log("new position",position);
    setShowMap(true);
  }, [position])

  function LocationMarker() {
    return position === null ? null : (
      <Marker position={position}>
        <Popup>Your Device Serial {deviceSerial}</Popup>
      </Marker>
    )
  }

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
  }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
          {dashData1 && 
            <PageHeader
              HeaderText="My Device Location"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "My Device Location", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
            />
          }
        <div>
        <h4>Your Device GPS Location</h4>
        {showMap && 
        <MapContainer center={position} zoom={zoom} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              <span>
                A pretty CSS3 popup. <br /> Easily customizable.
              </span>
            </Popup>
          </Marker>
          <LocationMarker />
        </MapContainer>
        }
      </div>

      </div>
      </div>
      </div>
    );
}
